module.exports = __webpack_public_path__ + "static/fields-683009cbb7e3f6afc931efa5bd8a53de.png";